import styles from './Alert.module.css';

import type { ReactNode } from 'react';

type AlertTone = 'success' | 'warning' | 'error' | 'info';

interface AlertProps {
  readonly tone: AlertTone;
  readonly title?: string;
  readonly children: ReactNode;
}

/** Ícone por tom: cor nunca é o único portador de significado (NFR-96). */
const ICONS: Readonly<Record<AlertTone, string>> = {
  success: '✓',
  warning: '⚠',
  error: '✕',
  info: 'ℹ',
};

/**
 * Aviso em bloco.
 *
 * Erro e aviso usam <code>role="alert"</code> — são interrupções, e o leitor de
 * tela precisa anunciá-los na hora. Sucesso e informação usam
 * <code>role="status"</code>, que espera a pausa: interromper a leitura para
 * dizer "salvo com sucesso" atrapalha mais do que ajuda.
 */
export function Alert({ tone, title, children }: AlertProps): JSX.Element {
  return (
    <div
      className={`${styles.alert} ${styles[tone]}`}
      role={tone === 'error' || tone === 'warning' ? 'alert' : 'status'}
    >
      <span aria-hidden="true" className={styles.icon}>
        {ICONS[tone]}
      </span>
      <div>
        {title !== undefined && <strong className={styles.title}>{title}</strong>}
        <div>{children}</div>
      </div>
    </div>
  );
}
